import { connect } from 'react-redux';
import Permanent from '../../../views/Personnel/Letter/Permanent.letter.view';
import { getPermanent } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetPermanent: payload => dispatch(getPermanent(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Permanent);
